import './deployments.css';

interface DeployProgressBarProps {
  /** 0 to 100, or null when there is nothing to measure yet: the bar then moves by itself. */
  percent: number | null;
  size?: 'sm' | 'md';
  label: string;
}

/** One bar for every deploy: the theme's fill on the theme's track, whether it measures or just moves. */
export function DeployProgressBar({ percent, size = 'md', label }: DeployProgressBarProps) {
  const moving = percent === null;
  return (
    <div
      className={`deploy-bar deploy-bar--${size}${moving ? ' deploy-bar--moving' : ''}`}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={moving ? undefined : percent}
    >
      <div className="deploy-bar__fill" style={moving ? undefined : { width: `${percent}%` }} />
    </div>
  );
}

export interface BarSegment {
  key: string;
  label: string;
  count: number;
}

interface SegmentedBarProps {
  segments: BarSegment[];
  total: number;
}

/** One bar cut into parts: how many clients of a group run succeeded, failed, are running and are waiting. */
export function SegmentedBar({ segments, total }: SegmentedBarProps) {
  const sum = Math.max(1, total);
  const summary = segments.map((s) => `${s.count} ${s.label.toLowerCase()}`).join(', ');
  return (
    <div className="deploy-segbar" role="img" aria-label={summary}>
      {segments
        .filter((segment) => segment.count > 0)
        .map((segment) => (
          <div
            key={segment.key}
            className={`deploy-segbar__seg deploy-segbar__seg--${segment.key}`}
            style={{ width: `${(segment.count / sum) * 100}%` }}
            title={`${segment.count} ${segment.label.toLowerCase()}`}
          />
        ))}
    </div>
  );
}
